import * as React from 'react';

import { Styled } from '../styled';

export class CleanInput extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const { onChange, additionalParams } = this.props;
    onChange &&
      onChange(
        additionalParams
          ? { newValue: e.target.value, ...additionalParams }
          : e.target.value
      );
  }

  render() {
    const {
      width = '100%',
      headerText,
      value,
      autofocus,
      onKeyPress,
      onBlur,
      onFocus,
      placeholder,
      inputRef,
    } = this.props;
    return (
      <Styled.InputContainer width={width}>
        <Styled.InputStyle
          ref={inputRef}
          onChange={this.handleChange}
          onKeyPress={onKeyPress}
          onBlur={onBlur}
          onFocus={onFocus}
          value={value}
          autoFocus={autofocus}
          text={headerText}
          placeholder={placeholder}
        />
        <Styled.InputText value={value}>{headerText}</Styled.InputText>
      </Styled.InputContainer>
    );
  }
}
